module.exports = __webpack_public_path__ + "img/btn_changeAdd.f788d3b2.png";